const FAQS = [
  {
    q: '如何下载漫画离线阅读？',
    a: '在任意漫画详情页点击"下载"按钮，选择需要下载的章节即可。下载后的漫画保存在本地，在"我的下载"中查看，无需联网即可随时阅读。支持批量下载和自动清理已读章节，节省手机存储空间。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '不同漫画的更新频率根据原作连载情况而定。热门连载漫画通常每周更新一话，部分日漫为双周刊。我们会在第一时间同步官方更新，并通过追更提醒功能通知你，确保你不错过任何精彩剧情。',
  },
  {
    q: '是否需要注册才能阅读漫画？',
    a: '游客模式下即可免费浏览和阅读大部分漫画内容。注册账号后可以使用收藏、追更提醒、多端同步、评论互动等高级功能。注册完全免费，只需邮箱或手机号即可快速完成。',
  },
  {
    q: '樱花漫画支持哪些设备阅读？',
    a: '我们提供iOS和安卓移动客户端，同时支持网页版在电脑浏览器中直接阅读。阅读进度、收藏和下载记录可在手机、平板、电脑之间无缝同步，切换设备后自动续读，体验流畅不受限。',
  },
  {
    q: '漫画资源是否为正版授权？',
    a: '樱花漫画致力于为读者提供优质的阅读体验，我们与多家国内外漫画版权方保持合作，持续引入正版漫画内容。所有上架作品均经过版权审核，确保为读者提供合法合规的阅读服务。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于樱花漫画，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-xs group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}